import { render, staticRenderFns } from "./CenterViewEventEdit_Ap.vue?vue&type=template&id=63852fa2&scoped=true"
import script from "./CenterViewEventEdit_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventEdit_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventEdit_Ap.vue?vue&type=style&index=0&id=63852fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63852fa2",
  null
  
)

export default component.exports